import { createClient } from 'contentful';

const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_DELIVERY_TOKEN;

if (!spaceId || !accessToken) {
  console.error('⚠️ Contentful credentials missing!');
  console.error('Please add to .env file:');
  console.error('REACT_APP_CONTENTFUL_SPACE_ID=your_space_id');
  console.error('REACT_APP_CONTENTFUL_DELIVERY_TOKEN=your_delivery_token');
}

const client = createClient({
  space: spaceId || 'placeholder',
  accessToken: accessToken || 'placeholder',
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master',
});

export default client;

